// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface YoutubeIconSignature {
  Element: SVGSVGElement;
}

export const YoutubeIcon: TOC<YoutubeIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 5.1C20.9 5.2 21.5 5.3 22.1 6.4C22.8 7.5 23.1 9.2 23 12.5C23 15.7 22.8 17.5 22.1 18.6C21.5 19.6 20.8 19.8 19.5 19.9C18.2 20 14.9 20 12 20C9.2 20 5.8 20 4.5 19.9C3.1 19.8 2.5 19.7 1.9 18.6C1.3 17.6 1 15.7 1 12.5C1 9.3 1.2 7.5 1.9 6.4C2.5 5.3 3.2 5.2 4.5 5.1C5.8 5 9.1 5 12 5C14.8 5 18.2 5 19.5 5.1ZM9.2 8.4V16.7L16.1 12.6L9.2 8.4Z"/>
</svg>
</template>;